import React, { Fragment } from 'react'
import Breadcrumbs from '../../../CommonElements/Breadcrumbs'
import { DashboardTitle, DefaultDashboardTitle, DefaultTitle } from '../../../Utils/Constants'
import { Container, Row } from 'reactstrap'
import WelcomeCard from './WelcomeCard'
import DailyRevenueCard from './DailyRevenueCard'
import NewCustomers from './NewCustomers'
import GrossCategories from './GrossCategories'
import TotalRevenue from './TotalRevenue'
import YearlyOverview from './YearlyOverview'
import NewsUpdate from './NewsUpdate'
import GoalOverviewSec from './GoalOverviewSec'
import TotalSale from './TotalSale'
import SellingProduct from './SellingProduct'

export default function DefaultDashboard() {
    return (
        <Fragment>
            <Breadcrumbs pageTitle={DefaultDashboardTitle} parent={DashboardTitle} title={DefaultTitle} />
            <Container className="default-dashboard" fluid>
                <Row>
                    <WelcomeCard />
                    <DailyRevenueCard/>
                    <NewCustomers/>
                    <GrossCategories/>
                    <TotalRevenue/>
                    <YearlyOverview/>
                    <NewsUpdate/>
                    <GoalOverviewSec/>
                    <TotalSale/>
                    <SellingProduct/>
                </Row>
            </Container>
        </Fragment>
    )
}